import React, { useState, useEffect } from 'react';
import { scrollProgress } from '../../context/ScrollContext';
import { SECTIONS } from '../../hooks/useScrollSection';

const SpatialHUD = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [sectionProgress, setSectionProgress] = useState(0);

  useEffect(() => {
    let frameId;
    const update = () => {
      const t = scrollProgress.value;

      for (let i = SECTIONS.length - 1; i >= 0; i--) {
        if (t >= SECTIONS[i].start) {
          setCurrentIndex(i);
          const range = SECTIONS[i].end - SECTIONS[i].start;
          const progress = range > 0 ? (t - SECTIONS[i].start) / range : 0;
          setSectionProgress(Math.min(Math.max(progress, 0), 1));
          break;
        }
      }

      frameId = requestAnimationFrame(update);
    };
    frameId = requestAnimationFrame(update);
    return () => cancelAnimationFrame(frameId);
  }, []);

  const current = SECTIONS[currentIndex];
  const next = SECTIONS[Math.min(currentIndex + 1, SECTIONS.length - 1)];

  return (
    <div
      className="spatial-hud"
      style={{
        position: 'fixed',
        bottom: '32px',
        left: '32px',
        zIndex: 100,
        pointerEvents: 'none',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '8px',
      }}
    >
      <div
        className="text-caption"
        style={{ opacity: 0.4, color: 'var(--text-muted)', fontSize: '0.7rem' }}
      >
        {String(currentIndex + 1).padStart(2, '0')} / {String(SECTIONS.length).padStart(2, '0')} — {current.name}
      </div>

      <div
        style={{
          width: '2px',
          height: '40px',
          background: 'var(--border)',
          borderRadius: '1px',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: `${sectionProgress * 100}%`,
            background: 'var(--accent)',
            borderRadius: '1px',
            transition: 'height 0.1s linear',
          }}
        />
      </div>

      {currentIndex < SECTIONS.length - 1 && (
        <div
          className="text-caption"
          style={{ opacity: 0.25, color: 'var(--text-muted)', fontSize: '0.6rem' }}
        >
          NEXT: {next.name}
        </div>
      )}

      <style>
        {`
          @media (max-width: 768px) {
            .spatial-hud {
              bottom: 16px !important;
              left: 16px !important;
              transform: scale(0.85);
              transform-origin: bottom left;
            }
          }
        `}
      </style>
    </div>
  );
};

export default SpatialHUD;
